import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import axios from "axios";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { useNavigate } from "react-router-dom";

function CSKH() {
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => {
            if (res.data && res.data.data) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch(() => localStorage.removeItem("user"));
    }, []);

    return (
        <div style={{ background: "#f8f9fb", minHeight: "100vh", paddingBottom: "80px", color: "#333" }}>
            <style>{`
                .cskh-header {
                    background: #fff;
                    height: 50px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: sticky;
                    top: 0;
                    z-index: 100;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.03);
                }
                .cskh-back {
                    position: absolute;
                    left: 10px;
                    cursor: pointer;
                    color: #333;
                    display: flex;
                    align-items: center;
                }
                .cskh-title {
                    font-size: 16px;
                    font-weight: 700;
                    color: #333;
                }
                .cskh-banner-container {
                    padding: 12px 15px;
                }
                .cskh-banner-img {
                    width: 100%;
                    border-radius: 12px;
                    display: block;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
                }
                .cskh-content {
                    padding: 0 15px;
                }
                .service-card {
                    background: #fff;
                    border-radius: 15px;
                    padding: 18px 15px;
                    display: flex;
                    align-items: center;
                    text-decoration: none;
                    gap: 15px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
                    border: 1px solid #f1f3f5;
                    transition: all 0.2s ease;
                }
                .service-card:active {
                    transform: scale(0.98);
                    background: #fafafa;
                }
                
                /* FIX LỖI ICON TO */
                .icon-box-small {
                    width: 38px;
                    height: 38px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #f0f4ff;
                    color: #5c7cff;
                    flex-shrink: 0;
                }
                .icon-box-small svg {
                    font-size: 22px !important; /* Cố định kích thước icon tai nghe */
                }

                .text-box {
                    flex: 1;
                }
                .text-box h3 {
                    margin: 0;
                    font-size: 15px;
                    font-weight: 700;
                    color: #2d3436;
                }
                .text-box p {
                    margin: 4px 0 0;
                    font-size: 12px;
                    color: #888;
                    line-height: 1.4;
                }
                
                .arrow-right-small {
                    color: #d1d8e0;
                    display: flex;
                    align-items: center;
                }
                .arrow-right-small svg {
                    font-size: 24px !important; /* Cố định kích thước mũi tên */
                }

                .support-hint {
                    text-align: center;
                    padding: 30px 20px;
                    color: #999;
                    font-size: 12px;
                    line-height: 1.8;
                }
            `}</style>

            {/* Top Navigation */}
            <div className="cskh-header">
                <div className="cskh-back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon style={{ fontSize: "32px" }} />
                </div>
                <div className="cskh-title">Trung tâm hỗ trợ</div>
            </div>

            {/* Banner Section */}
            <div className="cskh-banner-container">
                <img
                    className="cskh-banner-img"
                    src={require("../../img/CSKH-cover-blue@2x.7365166c.png")}
                    alt="Banner"
                />
            </div>

            {/* Support Options */}
            <div className="cskh-content">
                {setting?.cskh && (
                    <a href={setting.cskh} target="_blank" rel="noreferrer" className="service-card">
                        <div className="icon-box-small">
                            <HeadsetMicIcon />
                        </div>
                        <div className="text-box">
                            <h3>Hỗ trợ trực tuyến 24/7</h3>
                            <p>Giải đáp mọi thắc mắc về tài khoản & nạp rút</p>
                        </div>
                        <div className="arrow-right-small">
                            {/* Dùng icon quay ngược lại để làm mũi tên sang phải */}
                            <KeyboardArrowLeftOutlinedIcon style={{ transform: "rotate(180deg)" }} />
                        </div>
                    </a>
                )}

                <div className="support-hint">
                    Hệ thống hỗ trợ làm việc liên tục 24/7 kể cả ngày lễ.<br />
                    Vui lòng chọn kênh hỗ trợ phía trên để được kết nối.
                </div>
            </div>

        </div>
    );
}

export default CSKH;